'use client'

import { Col } from '@repo/ui/components'
import { SquareTokenImagesSection } from './square-token-images.section'
import { SquareTokenHeroSection } from './square-token-hero.section'
import { SquareTokenMethodsSection } from './square-token-methods.section'
import { SquareTokenRewardSection } from './square-token-reward.section'
import { SquareTokenSellSection } from './square-token-sell.section'

export const SquareTokenContainer = () => {
  return (
    <>
      <SquareTokenImagesSection />
      <Col className='relative z-0 w-full !max-w-container-xl mx-auto'>
        <SquareTokenHeroSection />
        <SquareTokenMethodsSection />
        <SquareTokenRewardSection />
        <SquareTokenSellSection />
      </Col>
    </>
  )
}
